export default __webpack_public_path__ + "static/auctux-4d11b17a9f1edc7e560e515076d1902e.png";